import { render, staticRenderFns } from "./GerentesRegionais.vue?vue&type=template&id=3ea5b3dc&scoped=true&lang=pug"
import script from "./GerentesRegionais.vue?vue&type=script&lang=js"
export * from "./GerentesRegionais.vue?vue&type=script&lang=js"
import style0 from "./GerentesRegionais.vue?vue&type=style&index=0&id=3ea5b3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea5b3dc",
  null
  
)

export default component.exports